export enum ConversationInquiryTypeEnum {
  ABOUT_LISTING = 1, // 出品について
  ABOUT_TRANSACTION = 2, // 取引について
  ABOUT_ISSUE = 3, // 不具合について
  OTHERS = 4, // その他
}

export const ConversationInquiryType = [
  {
    value: ConversationInquiryTypeEnum.ABOUT_LISTING,
    label: "出品について",
  },
  {
    value: ConversationInquiryTypeEnum.ABOUT_TRANSACTION,
    label: "取引について",
  },
  {
    value: ConversationInquiryTypeEnum.ABOUT_ISSUE,
    label: "不具合について",
  },
  {
    value: ConversationInquiryTypeEnum.OTHERS,
    label: "その他",
  },
];

export const ConversationInquiryTypeText = (type: number): string => {
  switch (type) {
    case ConversationInquiryTypeEnum.ABOUT_LISTING:
      return "出品について";
    case ConversationInquiryTypeEnum.ABOUT_TRANSACTION:
      return "取引について";
    case ConversationInquiryTypeEnum.ABOUT_ISSUE:
      return "不具合について";
    case ConversationInquiryTypeEnum.OTHERS:
      return "その他";
    default:
      return "____";
  }
};
